export default function ArtworkCard({ artwork, onClick }) {
  // Use first image from the array
  const firstImage = artwork.images[0]

  return (
    <div
      onClick={onClick}
      className="group cursor-pointer bg-white rounded-lg overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick()
        }
      }}
      aria-label={`Ansicht ${artwork.title}`}
    >
      {/* Artwork Image */}
      <div className="aspect-square overflow-hidden bg-neutral-100">
        <picture>
          <source
            srcSet={firstImage.medium}
            type="image/webp"
          />
          <img
            src={firstImage.fallback}
            alt={artwork.title}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
            loading="lazy"
          />
        </picture>
      </div>

      {/* Artwork Info */}
      <div className="p-5">
        <h3 className="text-lg font-serif text-primary mb-2 group-hover:text-secondary transition-colors line-clamp-2">
          {artwork.title}
        </h3>
        <div className="text-sm text-neutral-600 space-y-1">
          <p className="font-medium">{artwork.year}</p>
          <p className="text-xs">
            {artwork.dimensions.width} × {artwork.dimensions.height} cm
          </p>
          <p className="text-xs text-neutral-500">{artwork.medium}</p>
        </div>

        {/* View Details Hint */}
        <div className="mt-3 text-xs text-primary opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center">
          <span>Ansehen</span>
          <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </div>
    </div>
  )
}
